// A dónde se manda al usuario después de `POST /subscriptions/checkout`.
//
// Hay dos respuestas válidas:
//   • licencia de pago → `url` del Checkout hospedado de Stripe;
//   • licencia gratuita → `free: true` sin `url`: el servidor ya la activó y no
//     hay nada que cobrar, así que se entra por la pantalla de vuelta de la app
//     (que comprueba el estado real de cobro y pasa a la bienvenida o al mapa).
// Cualquier otra cosa es un error de checkout.
//
// Lógica pura, sin red ni Firebase, para poder probarla sola.

/** A dónde se manda a quien activó una licencia gratuita (sin Stripe). */
export const FREE_LICENSE_ENTRY_PATH = "/purchase/success?free=1";

/**
 * @param body cuerpo de la respuesta (`res.data`), con o sin sobre `data`
 * @param origin origen de la consola (`window.location.origin`)
 * @returns la URL de destino, o null si la respuesta no trae ninguna salida
 */
export function checkoutDestination(body: unknown, origin: string): string | null {
  const root = ((body as any)?.data ?? body ?? {}) as Record<string, any>;
  const payload = (root.data ?? root) as Record<string, any>;
  const url = root.url || payload.url;
  if (typeof url === "string" && url) return url;
  if (payload.free === true || root.free === true) return `${origin}${FREE_LICENSE_ENTRY_PATH}`;
  return null;
}
